import { API_ENDPOINTS } from '../config/api'
import type {
  FetchSharedLedgerResponse,
  FetchSharedLedgerRecoveryResponse,
  LedgerSafeSharedSnapshot,
  PublishSharedLedgerResponse,
} from '../types/sharedLedgerSnapshots'

const parseJsonResponse = async <T>(response: Response): Promise<T> => {
  const payload = await response.json().catch(() => null)
  if (!response.ok) {
    const detail = payload && typeof payload === 'object' && 'detail' in payload
      ? String((payload as { detail?: unknown }).detail || '')
      : ''
    throw new Error(detail || `Shared collation request failed: HTTP ${response.status}`)
  }
  return payload as T
}

export const publishSharedLedgerSnapshot = async (
  snapshot: LedgerSafeSharedSnapshot
): Promise<PublishSharedLedgerResponse> => {
  const response = await fetch(API_ENDPOINTS.sharedLedgers.create, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ snapshot }),
  })
  return parseJsonResponse<PublishSharedLedgerResponse>(response)
}

export const fetchSharedLedgerSnapshot = async (
  shareId: string
): Promise<FetchSharedLedgerResponse> => {
  const response = await fetch(API_ENDPOINTS.sharedLedgers.get(shareId), {
    headers: { Accept: 'application/json' },
    credentials: 'include',
  })
  return parseJsonResponse<FetchSharedLedgerResponse>(response)
}

export const fetchSharedLedgerRecoverySnapshot = async (
  shareId: string
): Promise<FetchSharedLedgerRecoveryResponse> => {
  const response = await fetch(API_ENDPOINTS.sharedLedgers.recover(shareId), {
    method: 'POST',
    headers: { Accept: 'application/json' },
    credentials: 'include',
  })
  return parseJsonResponse<FetchSharedLedgerRecoveryResponse>(response)
}
